/**
 * Application Constants
 */

// Validation limits
export const MAX_TITLE_LENGTH = 50;
export const MAX_BODY_LENGTH = 500;
export const MIN_TITLE_LENGTH = 3;
export const MIN_BODY_LENGTH = 10;

// Breakpoints
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 1024;

// Time constants (in milliseconds)
export const MS_PER_MINUTE = 1000 * 60;
export const MS_PER_HOUR = MS_PER_MINUTE * 60;
export const MS_PER_DAY = MS_PER_HOUR * 24;

// Tabs
export const TAB_NOTES = 'notes';
export const TAB_ARCHIVE = 'archive';
